import * as React from 'react'
import { useMemo } from 'react'
import { useTransactionCount } from './hooks'
import { Card, Statistic, Flex, Spin, Tooltip } from 'antd'
import { SwapOutlined } from '@ant-design/icons'
import { Column } from '@ant-design/plots'
import { path } from '../../../../libs'

export const TransactionCountWidget = () => {
  const { transactionCount, transactionCountByMonth, loading } =
    useTransactionCount()

  const chartData = useMemo(() => {
    const items = Array.isArray(transactionCountByMonth)
      ? transactionCountByMonth
      : []
    return [...items]
      .sort(
        (a, b) =>
          new Date(a.txn_month.split(' ')[0]).getTime() -
          new Date(b.txn_month.split(' ')[0]).getTime(),
      )
      .map((d) => ({
        date: d.txn_month.split(' ')[0],
        count: d.request_count,
      }))
  }, [transactionCountByMonth])

  return (
    <Card size="small" style={{ flex: 1, minWidth: 320 }}>
      <Spin spinning={loading}>
        <Statistic
          title={
            <Flex align="center" gap={6}>
              <SwapOutlined style={{ color: '#f59e0b' }} />
              <Tooltip title="Общее количество депозитов и выводов. График — подтверждённые транзакции по месяцам.">
                <a
                  target="_blank"
                  href={path.billing.transactions.entry()}
                  style={{ fontSize: 12, color: 'inherit' }}
                >
                  Transactions
                </a>
              </Tooltip>
            </Flex>
          }
          value={transactionCount.count.toLocaleString('ru-RU')}
          valueStyle={{
            fontSize: 28,
            fontFamily: 'monospace',
            fontWeight: 600,
          }}
        />
        {chartData.length > 1 && (
          <div style={{ height: 180, marginTop: 12 }}>
            <Column
              data={chartData}
              xField="date"
              yField="count"
              height={180}
              style={{ fill: '#f59e0b' }}
              axis={{
                x: {
                  label: {
                    style: { fontSize: 10 },
                    autoRotate: true,
                    formatter: (v: string) => {
                      const d = new Date(v)
                      return d.toLocaleDateString('ru-RU', { month: 'short', year: '2-digit' })
                    },
                  },
                },
                y: {
                  label: {
                    style: { fontSize: 10 },
                  },
                },
              }}
              legend={false}
              tooltip={(d: { date: string; count: number }) => ({
                name: 'Transactions',
                value: d.count,
              })}
            />
          </div>
        )}
      </Spin>
    </Card>
  )
}
